import { configureStore } from '@reduxjs/toolkit'
import thunk from 'redux-thunk'
import activityReducer from './activity'
import adversariesReducer from './adversaries'
import alertsReducer from './alerts'
import blocklistReducer from './blocklist'
import devicesReducer from './devices'
import integrationsReducer from './integrations'
import membersReducer from './members'
import settingsReducer from './settings'
import statsReducer from './stats'
import travelReducer from './travel'
import userReducer from './users'
import groupsReducer from './groups'

export type RootState = {
  activity: ReturnType<typeof activityReducer>
  adversaries: ReturnType<typeof adversariesReducer>
  alerts: ReturnType<typeof alertsReducer>
  blocklist: ReturnType<typeof blocklistReducer>
  devices: ReturnType<typeof devicesReducer>
  integrations: ReturnType<typeof integrationsReducer>
  members: ReturnType<typeof membersReducer>
  settings: ReturnType<typeof settingsReducer>
  stats: ReturnType<typeof statsReducer>
  travel: ReturnType<typeof travelReducer>
  user: ReturnType<typeof userReducer>
  groups: ReturnType<typeof groupsReducer>
}

const createStore = (initialState?: Partial<RootState>) => {
  return configureStore({
    reducer: {
      activity: activityReducer,
      adversaries: adversariesReducer,
      alerts: alertsReducer,
      blocklist: blocklistReducer,
      devices: devicesReducer,
      integrations: integrationsReducer,
      members: membersReducer,
      settings: settingsReducer,
      travel: travelReducer,
      stats: statsReducer,
      user: userReducer,
      groups: groupsReducer,
    },
    middleware: [thunk],
    preloadedState: initialState,
  })
}

export default createStore
